import { ASSIGNABLE_ROLES, type CustomRole, type MemberRole } from '@/entities/collab';
import type { Workspace } from '@/entities/workspace';

/** Standard roles the viewer may hand out: all (owner / lead moderator) or strictly below. */
export function assignableStandardRoles(workspace: Workspace): MemberRole[] {
  if (workspace.is_owner || (workspace.role === 'lead_moderator' && !workspace.custom_role_id)) {
    return [...ASSIGNABLE_ROLES];
  }
  const index = ASSIGNABLE_ROLES.indexOf(workspace.role);
  return index < 0 || workspace.custom_role_id ? [] : ASSIGNABLE_ROLES.slice(index + 1);
}

/**
 * Whether the viewer may hand out the custom role: it must not carry a permission the viewer
 * lacks (the server also checks the level and always has the last word).
 */
export function isGrantableRole(workspace: Workspace, role: CustomRole): boolean {
  return (
    workspace.is_owner ||
    (workspace.role === 'lead_moderator' && !workspace.custom_role_id) ||
    role.permissions.every((permission) => workspace.permissions.includes(permission))
  );
}
